import {
  Badge,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@geely/ui";
import { Pencil, Trash2 } from 'lucide-react';
import type { UserWithoutPassword } from '@geely/shared';

interface UsersTableProps {
  users: UserWithoutPassword[];
  getStoreNames: (storeIds: string[]) => string;
  onEdit: (user: UserWithoutPassword) => void;
  onDelete: (id: string) => void;
}

export function UsersTable({ users, getStoreNames, onEdit, onDelete }: UsersTableProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Usuários Cadastrados</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nome</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Nível de Permissão</TableHead>
                <TableHead>Lojas</TableHead>
                <TableHead className="text-right">Ações</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.id}>
                  <TableCell className="font-medium">{user.name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>
                    <Badge variant={user.role === 'admin' ? 'default' : 'secondary'}>
                      {user.role === 'admin' ? 'Admin Geral' : 'Admin de Loja'}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    {(() => {
                      const ids = user.storeIds ?? [];
                      if (ids.length === 0) return '-';
                      const visible = getStoreNames(ids.slice(0, 2));
                      const remaining = ids.length - 2;
                      return remaining > 0 ? `${visible}... +${remaining}` : visible;
                    })()}
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onEdit(user)}
                      >
                        <Pencil className="size-4" />
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onDelete(user.id)}
                      >
                        <Trash2 className="size-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
